import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { Input } from 'reactstrap';

var defaultConfigurableText = {
    prefix: 'Page',
    infix: 'of'
};
var PageIndexInput = function (_a) {
    var numPages = _a.numPages, _b = _a.configurableText, configurableText = _b === void 0 ? defaultConfigurableText : _b, onPageIndexChange = _a.onPageIndexChange, pageIndex = _a.pageIndex;
    var _c = useState(pageIndex), value = _c[0], setValue = _c[1];
    useEffect(function () {
        setValue(pageIndex + 1);
    }, [pageIndex]);
    var onSubmit = function () {
        var pgIndex = value ? Math.max(1, Math.min(Number(value), numPages)) - 1 : 0;
        onPageIndexChange(pgIndex);
        setValue(pageIndex + 1);
    };
    var onKeyDown = function (e) {
        if (e.key === 'Enter') {
            onSubmit();
        }
    };
    return (jsxs("div", __assign({ className: "react-table-pagination-total d-inline-block", "data-testid": "page-index-input" }, { children: [(configurableText === null || configurableText === void 0 ? void 0 : configurableText.prefix) && "".concat(configurableText.prefix, " "), jsx(Input, { type: "number", value: value, onChange: function (e) { return setValue(e.target.value ? e.target.valueAsNumber : ''); }, onKeyDown: onKeyDown, onBlur: onSubmit, className: "d-inline-block mx-3", style: { width: '80px' }, "data-testid": "pagination-page-input" }), (configurableText === null || configurableText === void 0 ? void 0 : configurableText.infix) && " ".concat(configurableText.infix, " "), numPages, (configurableText === null || configurableText === void 0 ? void 0 : configurableText.suffix) && " ".concat(configurableText.suffix)] })));
};

export { PageIndexInput, defaultConfigurableText };
